// Componente Stepper para visualização de progresso do wizard
import { Check } from 'lucide-react';
import { cn } from '../../utils/cn';

interface StepperProps {
  steps: { label: string; icon?: React.ReactNode }[];
  currentStep: number;
}

export function Stepper({ steps, currentStep }: StepperProps) {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          const isPending = index > currentStep;

          return (
            <div key={index} className="flex items-center flex-1">
              {/* Step Circle */}
              <div className="flex flex-col items-center flex-1">
                <div
                  className={cn(
                    'w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300',
                    'shadow-lg',
                    isCompleted && 'bg-primary-600 text-white shadow-primary-500/30',
                    isCurrent && 'bg-primary-600 text-white ring-4 ring-primary-500/30 shadow-primary-500/30 scale-110',
                    isPending && 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400'
                  )}
                >
                  {isCompleted ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    <span className="text-sm font-semibold">{index + 1}</span>
                  )}
                </div>
                {/* Step Label */}
                <div className="mt-2 text-center">
                  <p
                    className={cn(
                      'text-xs font-medium transition-colors duration-300',
                      isCompleted && 'text-primary-600 dark:text-primary-400',
                      isCurrent && 'text-primary-600 dark:text-primary-400 font-semibold',
                      isPending && 'text-gray-500 dark:text-gray-400'
                    )}
                  >
                    {step.label}
                  </p>
                </div>
              </div>
              
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="flex-1 h-0.5 mx-2 -mt-5">
                  <div
                    className={cn(
                      'h-full transition-all duration-300',
                      isCompleted ? 'bg-primary-600' : 'bg-gray-200 dark:bg-gray-700'
                    )}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
